<template>
  <div class="modal" id="staticBackdrop" tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true"
       role="dialog"
       style="display:block; background-color:rgba(255, 255, 255, 0.6);">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">차량 등록</h5>
          <button type="button" class="btn-close" @click="$emit('close')"></button>
        </div>

        <div class="modal-body">
          <div class="info-div">
            <table class="info-table">
              <tbody>
              <tr>
                <th class="w-50">운수사</th>
                <td class="w-50">
                  <input
                    class="form-control"
                    v-model="officeIdRef"
                    :placeholder="'ex)1234567890'"
                    :disabled="props.officeId !== undefined"
                  >
                </td>
              </tr>
              <tr>
                <th>사원번호</th>
                <td>
                  <input class="form-control" v-model="vehicleEntity.driverId"
                         :placeholder="'ex)1111(4자리)'">
                </td>
              </tr>
              <tr>
                <th>차량번호</th>
                <td>
                  <input class="form-control" v-model="vehicleEntity.carNum"
                         :placeholder="'ex)서울99가9999'">
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="$emit('close')">취소</button>
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="clickSaveBtn">등록</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineProps, onMounted, ref} from "vue";
import {useStore} from "vuex";
import tachoEntity from "@/entity/TachoEntity";
import Entity from "@/entity/OperationEntity";
import {validateCarNum, validateEmployeeNum} from "@/components/tacho/common/CommonFunc";

const url = tachoEntity.baseUrl;
const store = useStore();
const operationUrl = store.state['api'].operationUrl;
const entity = new Entity.organizationHeaders(store.state.sign['userInfo'].userId);
const headers = entity.get();

const setLoading = (value) => store.commit('setLoading', value)

const props = defineProps({
  type: String,
  officeId: String,
  carType: String,
})

const emit = defineEmits(['close', 'add']);
const officeIdRef = ref(props.officeId || '');

const vehicleEntity = new tachoEntity.vehicleEntity(
    '',
    '',
    'AAAA',
    props.carType,
);

onMounted(async () => {
})

const clickSaveBtn = () => {
  if (officeIdRef.value.length !== 10) {
    store.commit("openMessageBox", "운수사를 입력해 주세요.");
    return
  }

  if (vehicleEntity.driverId === "" || vehicleEntity.driverId === undefined) {
    store.commit("openMessageBox", "사원번호를 입력해 주세요.");
    return
  }

  if (!validateEmployeeNum(vehicleEntity.driverId)) {
    store.commit("openMessageBox", "사원번호가 형식에 맞지 않습니다.");
    return;
  }

  if (vehicleEntity.carNum === "" || vehicleEntity.carNum === undefined) {
    store.commit("openMessageBox", "차량번호를 입력해 주세요.");
    return
  }

  if (!validateCarNum(vehicleEntity.carNum)) {
    store.commit("openMessageBox", "차량번호가 형식에 맞지 않습니다.")
    return
  }

  vehicleEntity.officeId = officeIdRef.value
  emit('add', vehicleEntity);
}
</script>

<style scoped>
.modal-dialog {
  font-size: 0.8rem;
  min-width: 50rem;
}

.modal-body {
  padding: 0;
}

.inner-top button {
  border: none;
  padding: 0.25rem 2rem;
  margin: 5px;
  font-size: 13px;
  color: #ffffff;
  background-color: #000000;
}

.info-table {
  width: 100%;
}

.info-table tr {
  border-bottom: 1px solid var(--bs-modal-header-border-color);
}

.info-table tr:last-child {
  border: none;
}

.info-table th,
.info-table td {
  text-align: left;
  padding: 0.4rem 0.5rem !important;
}

.info-table th {
  background-color: rgba(248, 249, 250);
  width: 20%;
}

.info-table td {
  width: 30%;
}

.info-table td input,
.info-table td select {
  font-size: 13px;
}

button {
  color: #ffffff;
}

</style>
